export default __webpack_public_path__ + "static/media/add-image.0888f599.svg";